export default class MiniAppSetting {
  constructor(appTitle, colorCode, enableBackButton, centerTitle) {
    this.appTitle = appTitle;
    this.colorCode = colorCode;
    this.enableBackButton = enableBackButton;
    this.centerTitle = centerTitle;
  }
}
